<div class="cnav-bar">
  <div class="cnav-brand">
    <div class="cnav-mark">T</div>
    <span class="b8 fz16">Trexa</span>
  </div>
  <div class="cnav-tabs">
    <button type="button" class="cnav-tab" *ngFor="let item of items"
            [class.on]="isActive(item)"
            (click)="navigate(item.path)">{{ item.label }}</button>
  </div>
</div>
